import React, {useState} from "react";
import SummaryCard from "../../../../../app/components/SummaryCard";
import { FiUsers, FiGitBranch, FiList, FiClock, FiTrendingUp, FiPercent  } from "react-icons/fi";
import { GrRobot } from "react-icons/gr";
import GraphicCard from "../../../../../app/components/GraphicCard";
import Table from "../../../../../app/components/Table";

const Statics = () => {
    const loginGraphic = {
        id: 1,
        tipo: "barra",
        titulo: "Logins por dia (Últimos 7 dias)",
        linha: "Status",
        coluna: "Qtd",
        metrica: "Total",
    };

     const columnsStatics = [
         { campo: 'departamento', titulo: 'Departamento' },
        { campo: 'colaboradores', titulo: 'Colaboradores' },
        { campo: 'sequencia', titulo: 'Sequencia' },
        { campo: 'cards', titulo: 'Cards' },
        { campo: 'atividade', titulo: 'Atividade' },
    ];

    const [dataStatic, setDataStatic] = useState([
      { id: 1, sequencia: 2, departamento: 'Desenvolvimento', cards: '63', atividade: '100%', passivel_multa: 'Não', colaboradores: '' },
      { id: 2, sequencia: 6, departamento: 'Deploy e Testes', cards: '1', atividade: '100%', passivel_multa: 'Não', colaboradores: '' },
      { id: 3, sequencia: 3, departamento: 'Sucesso', cards: '123', atividade: '0%', passivel_multa: 'Não', colaboradores: '' },
      { id: 4, sequencia: 1, departamento: 'Comercial', cards: '12', atividade: '100%', passivel_multa: 'Não', colaboradores: '' },
    ]);

    return(
        <div>
            <h2 class="text-lg font-medium text-gray-900 pt-4">Estatísticas de Uso da Organização</h2>
            <div className="grid grid-cols-2 xl:flex gap-4 mt-9">
                <SummaryCard
                icon={FiUsers}
                color="#3f1057"
                title='Usuários ativos de 10 colaboradores'
                value='9'
                />
                <SummaryCard
                icon={FiGitBranch}
                color="#672c71"
                title='Sequências ativas em produção'
                value='9'
                />
                <SummaryCard
                icon={FiList}
                color="#59337d"
                title='Cards ativos 371 finalizados'
                value='128'
                />
                <SummaryCard
                icon={GrRobot}
                color="#60449d"
                title='Automações ativas de 3 criadas'
                value='3'
                />
                <SummaryCard
                icon={FiClock}
                color="#414186"
                title='Sessões ativas nas últimas 24h'
                value='5'
                />
                <SummaryCard
                icon={FiTrendingUp}
                color="#494c9a"
                title='Relatórios configurados'
                value='0'
                />
                <SummaryCard
                icon={FiPercent}
                color="#3330bc"
                title='Taxa de sucesso de automações'
                value='3'
                />
            </div>
            <div className="pt-16">
                <GraphicCard
                    graphic={loginGraphic}
                    resizable
                    width={'100vw'}
                    height={400}
                    onDelete={() => console.log('Excluir gráfico')}
                    isStarred={false}
                    onToggleStar={() => console.log('Toggle favorito')}
                    onResize={(e, { size }) => console.log('Redimensionado para:', size)}
                />
            </div>
            <div className="pt-16 mb-10">
                <div className="flex mb-8 justify-between items-center">
                    <h2 class="text-lg font-medium text-gray-900 flex items-center">Estatísticas por Departamento</h2>
                    <span className="bg-[#3f1057] rounded-tr-2xl rounded-tl-2xl rounded-br-2xl text-xs py-1 px-2 text-white font-bold"> {dataStatic.length} Departamento{dataStatic.length !== 1 ? 's' : ''}</span>
                </div>
                <Table
                    colunas={columnsStatics}
                    dados={dataStatic}
                />
            </div>
        </div>
    )
}

export default Statics